import { useSelector } from "react-redux";
import BorderWrapper from "src/components/atoms/BorderWrapper";
import Chart from "src/components/molecules/Chart";
const Graph = () => {
  const chartData = useSelector((state) => state.global.chartData);
  return (
    <>
      <BorderWrapper>
        <>
          <div className="text-light-gray font-bold mb-5">Sales Chart</div>
          <Chart data={chartData} dataKeyX="name" dataKeyY="users" />
        </>
      </BorderWrapper>
    </>
  );
};

export default Graph;
